import { lazy } from "react";

export const ProjectSettingsView = lazy(() => import("./ProjectSettingsView"));
